import { styled } from '@withjoy/joykit';

export const StyledForm = styled.form`
  display: flex;
  justify-content: center;
`;
